<template>
  <div style="padding: 16px;">
    <div>
      <el-button
        type="primary"
        @click="insert"
        style="background: #EEF5FE;border-radius: 4px;color:#458CFF;font-size:14px;"
      >添加
      </el-button>
      <el-button
        type="primary"
        @click="importShow = true"
        style="background: #EEF5FE;border-radius: 4px;color:#458CFF;font-size:14px;"
      >导入
      </el-button>
    </div>
    <div style="margin-top: 16px;">
      <el-input placeholder="请输入条码/附加码" v-model="searChbarCode" @input="searchBarcode" clearable
                suffix-icon="el-icon-search"></el-input>
    </div>
    <div style="margin-top:16px;">
      <el-table :data="tableDataPage" :cell-style="{height: '40px'}" :header-cell-style="{height: '40px'}">
        <el-table-column label="序号" type="index" :index="(index) => { return index + 1}" width="200px"
                         align="center"></el-table-column>
        <el-table-column v-for="item in columnList" :key="item.key" :prop="item.prop" :label="item.label"
                         align="center"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template v-slot="scope">
            <div style="display: flex">
              <div style="color: #458CFF;cursor: pointer;" @click="handleDetail(scope.row)">查看</div>
              <div style="color: #458CFF;margin-left:35px;cursor: pointer;" @click="handleUpdate(scope.row)">编辑</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="tr"
        background
        :page-size="currentPageSize"
        :current-page="currentPageNo"
        @size-change="handlePageSizeChange"
        @current-change="changePage"
        :page-sizes="[10, 20, 50, 100]"
        style="margin-top:15px;"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="商品列表" :visible.sync="listShow"
               width="1200px" height="800"
               @close="handleInsertClose"
               :close-on-click-modal="false">
      <good-list
        v-if="step === 1"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :tableOptions="tableOptions"

        @selectSubmit="rowsSelectSubmit"
        :listTableData="listTableData"
      ></good-list>
      <div v-if="step=== 2" class="setCode">
        <div class="button">
          商品附加码：
          <el-input v-model="productCode" :maxlength="32">></el-input>
          <el-button type="primary" @click="add()" style="margin-left:8px;" :disabled="btnbool1">添加</el-button>
        </div>
        <div>
          <el-table :data="codeTableData" :cell-style="{height: '40px'}">
            <el-table-column label="序号" type="index" width="175" :index="(index) => { return index + 1}"
                             align="center"></el-table-column>
            <el-table-column label="附加码" prop="code" align="center"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span style="color: rgb(69, 140, 255); cursor: pointer" @click="deleteMultiCode(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="10"
            :current-page="currentBarCodePageNo"
            @current-change="changeBarCodePage"
            :page-sizes="[10, 20, 50, 100]"
            layout="prev, pager, next"
            :total="barCodeTotal">
          </el-pagination>
        </div>
        <!--      <table-template :tableData="codeTableData" :tableOptions="multiTableOptions" :toolConfig="MultiCodeConfig" ref="goodsCode">-->
        <!--      </table-template>-->
        <div class="button" style="justify-content: center;margin-top:10px;">
          <el-button @click="() =>{productCode = ''; step = 1}" type="info" plain>返回</el-button>
          <el-button @click="() =>{step = 1; listShow = false;productCode = ''; getTableData()}" type="primary">完成
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 更新附加码  -->
    <el-dialog title="一品多码" custom-class="barCodeDialog" @close="handleClose" :visible.sync="barCodeUpdateShow">
      <div style="display: flex;flex-direction: column;">
        <div class="button" style="margin-bottom: 10px;">
          商品附加码：
          <el-input v-model="productCode" :maxlength="32">></el-input>
          <el-button type="primary" @click="add()" style="margin-left:8px;" :disabled="btnbool1">添加</el-button>
        </div>
        <div>
          <el-table :data="codeTableData" :cell-style="{height: '40px'}">
            <el-table-column label="序号" type="index" width="175" :index="(index) => { return index + 1}"
                             align="center"></el-table-column>
            <el-table-column label="附加码" prop="code" align="center"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span style="color: rgb(69, 140, 255); cursor: pointer" @click="deleteMultiCode(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="10"
            :current-page="currentBarCodePageNo"
            @current-change="changeBarCodePage"
            :page-sizes="[10, 20, 50, 100]"
            layout="prev, pager, next"
            :total="barCodeTotal">
          </el-pagination>
        </div>
        <!--      <table-template :tableData="codeTableData" :tableOptions="multiTableOptions" :toolConfig="MultiCodeConfig" ref="goodsCode">-->
        <!--      </table-template>-->
        <div style="justify-content: center;margin-top:30px;display: flex;">
          <el-button @click="barCodeUpdateShow = false" type="primary">完成</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  查看附加码-->
    <el-dialog title="查看附加码" :visible.sync="barCodeCheckShow" @close="handleClose" custom-class="checkBarCode">
      <el-table :data="codeTableData" :cell-style="{height: '40px'}">
        <el-table-column label="序号" type="index" width="175" :index="(index) => { return index + 1}"
                         align="center"></el-table-column>
        <el-table-column label="附加码" prop="code" width="175" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="barCodeSize"
        :current-page="currentBarCodePageNo"
        @current-change="changeBarCodePage"
        :page-sizes="[10, 20, 50, 100]"
        layout="prev, pager, next"
        :total="barCodeTotal">
      </el-pagination>
      <!--    <table-template  :tableData="codeTableData"   :tableOptions="multiTableOptions"  ref="goodsCode">-->
      <!--    </table-template>-->
    </el-dialog>
    <!--  批量导入  -->
    <el-dialog title="批量导入" :visible.sync="importShow"
               @close="currentStep = 0;showDetail = false;operationRecordId = '';" :close-on-click-modal="false"
               custom-class="importDialog">
      <div style="padding:30px 66px;" v-if="!showDetail">
        <!--        <div style="display: flex; justify-content: center;align-items: center;">-->
        <!--          <div>-->
        <!--            <div :class="currentGoing === 1 ? 'activeGoing' : 'going'">1</div>-->
        <!--            <div :class="currentGoing === 1 ? 'activeGoing' : 'going'">上传数据</div>-->
        <!--          </div>-->
        <!--          <div class="fadeLine">-->
        <!--&lt;!&ndash;            <div > > </div>&ndash;&gt;-->
        <!--            <img class="centerArrow" src="/static/rightArrow.png" >-->
        <!--          </div>-->
        <!--          <div :class="currentGoing === 2 ? 'activeGoing' : 'going'">2</div>-->
        <!--          <div class="fadeLine">-->
        <!--            &lt;!&ndash;            <div > > </div>&ndash;&gt;-->
        <!--            <img class="centerArrow" src="/static/rightArrow.png" >-->
        <!--          </div>-->
        <!--          <div :class="currentGoing === 3 ? 'activeGoing' : 'going'">3</div>-->
        <!--        </div>-->

        <el-steps :active="currentStep" align-center class="cus-steps">
          <el-step title="上传数据"></el-step>
          <el-step title="导入数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <el-button v-if="currentStep < 1" type="primary" style="width: 100%;height:40px;margin-top:50px;"
                   :loading="currentStep !== 0 && currentStep !== 3" @click.prevent="importFile">立即导入
        </el-button>
        <div v-if="currentStep == 1" style="text-align: center;padding-bottom:40px;margin-top:90px;">
          <i style="font-size: 48px" class="el-icon-loading"></i>
          <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
            正在导入
          </div>
        </div>
        <!-- 有问题按键-->
        <el-button v-if="currentStep == 3 && operationRecordId" type="primary"
                   style="width: 100%;height:40px;margin-top:50px;"
                   @click.prevent="showDetail = true; getResult(operationRecordId)">查看详情
        </el-button>
        <div v-if="currentStep == 3 && !operationRecordId && !importStatus"
             style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
          </div>
          <span style="margin-top:12px;color:#FF553E;">导入结束</span>
        </div>
        <div v-if="currentStep == 3 && importStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
          </div>
          <span style="margin-top:12px;">导入成功！</span>
        </div>
        <!-- 第一页显示 -->
        <div v-if="currentStep < 1" style="color: #2A2A2A;font-size: 16px;font-weight: 300;margin-top:47px;">
          <div style="margin-bottom: 17px;">温馨提示:</div>
          <div>1、如果您还没有下载导入模板，请下载 <span @click.prevent="downLoadModel"
                                        style="cursor: pointer; color:#458CFF; text-decoration: underline;">一品多码导入模板</span>
          </div>
          <div style="margin-top: 14px;">2、单次可导入2000条以内的数据</div>
        </div>
      </div>
      <div v-else style="padding: 30px">
        <div
          style="margin-bottom:27px;padding:11px 14px;font-weight: 300;color: #FF553E; width: 100%;background: #FFF6F4;border-radius: 4px;">
          <i class="el-icon-circle-close"></i>
          导入失败{{ errorCount }}条商品
        </div>
        <el-table :data="errorData" :cell-style="{height:'40px' }" :header-cell-style="{height: '40px'}">
          <el-table-column label="序号" type="index" width="75" :index="(index) => { return index + 1}"
                           align="center"></el-table-column>
          <el-table-column label="条码" width="150" align="center" prop="barCode"></el-table-column>
          <el-table-column label="异常原因" width="330" align="center" prop="remarks"></el-table-column>
        </el-table>
        <el-pagination
          background
          :page-size="10"
          :current-page="errPageNo"
          @current-change="(val) =>{getResult({pageNumber: val })}"
          layout="prev, pager, next"
          :total="errorCount">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/config/api'
// 商品列表组件
import goodList from '@/components/business/goodList';
import tableTemplate from '@/components/template/tableTemplate';
import Img from '../../system/maintain/Img';

// 表单单组件
export default {
  name: 'BarCodeManage',
  components: {
    Img,
    goodList,
    tableTemplate
  },
  watch: {
    // 一品多码添加条形码监听事件
    productCode(newval, oldval) {
      if (this.productCode != '') {
        this.btnbool1 = false
      } else {
        this.btnbool1 = true
      }
    }
  },
  data() {
    return {
      codeTablePageSize: 10,
      barCodeSize: 10,
      errorData: [],
      errorCount: 0,
      barCodeTotal: 0,
      errPageNo: 1,
      importStatus: false,
      operationRecordId: '',
      showDetail: false,
      currentBarCodePageNo: 1,
      currentUpdateBarCodePageNo: 1,
      searChbarCode: '',
      currentStep: 0, // 状态2 表示啥也不是
      total: 0,
      importShow: false,
      barCodeTitle: '查看附加码',
      barCode: '',
      productCode: '',
      btnbool1: true,
      barCodeUpdateShow: false,
      barCodeCheckShow: false,
      currentPageSize: 10,
      currentPageNo: 1,
      listShow: false,
      merchantId: null,
      tableData: [],
      tableDataPage: [],
      codeTableData: [],
      listTableData: [],
      selectTarget: null,
      step: 1,
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '210',
            align: 'center'
          },
          {
            label: '品名',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80',
            align: 'center'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '150',
            align: 'center'
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '150',
            align: 'center'
          },
          {
            label: '库存',
            prop: 'inventoryNum',
            width: '150',
            align: 'center'
          }
        ],
        url: api.archives.goodsInfoIncludeSpecs
      },
      // 一品多码 column
      multiTableOptions: {
        indexShow: true,
        columns: [
          {label: '附加码', prop: 'code', width: 50, align: 'center'}
        ],
        param: {
          merchantId: this.merchantId,
          barCode: this.barCode
        },
        url: api.archives.getBarCodePage
      },
      // 一品多码操作集合
      MultiCodeConfig: [
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback: this.deleteMultiCode
        }
      ],
      columnList: [
        {
          label: '条码',
          prop: 'barCode',
          align: 'center'
        },
        {
          label: '品名',
          prop: 'goodsName',
          align: 'center'
        },
        {
          label: '规格',
          prop: 'specs',
          align: 'center'
        },
        {
          label: '单位',
          prop: 'unitName',
          align: 'center'
        }
      ]
    }
  },
  created() {
    const UserInfo = JSON.parse(localStorage.getItem('SYSUSER') || {});
    console.log(UserInfo)
    this.merchantId = UserInfo.merchantId
    this.getTableData()
  },
  methods: {
    handleSizeChange(val) {
      this.currentBarCodePageNo = 1;
      this.barCodeSize = val
      this.getBarCode(this.selectTarget.barCode)
    },
    getResult({operationRecordId = this.operationRecordId, pageNumber = this.errPageNo, pageSize = 10}) {
      const param =
        {
          pageNumber,
          pageSize,
          operationRecordId
        }
      this.$axios.fetchPost(api.archives.getErrorReason, param).then(res => {
        console.log(res)
        this.errorData = res.data.records
        this.errorCount = res.data.total;
      })
    },
    handleClose() {
      this.productCode = '';
      this.currentBarCodePageNo = 1
    },
    handlePageSizeChange(val) {
      this.currentPageNo = 1;
      this.currentPageSize = val;
      this.getTableData()
    },
    changeBarCodePage(val) {
      this.currentBarCodePageNo = val
      this.getBarCode(this.barCode)
    },
    changePage(val) {
      console.log(val)
      this.currentPageNo = val
      this.getTableData()
    },
    searchBarcode() {
      this.getTableData()
    },
    // 判断文件类型
    isExcellType(ext) {
      return ['xls', 'xlsx'].indexOf(ext.toLowerCase()) !== -1;
    },
    importFile() {
      this.$confirm('只能上传.xls/.xlsx文件')
        .then(_ => {
          this.$utils.uploadFile((file) => {
            console.log(file)
            this.importStatus = false; // 在这里初始化了导入的状态
            this.currentStep = 1;
            let formData = new FormData();
            formData.append('file', file);
            let index = file.name.lastIndexOf('.');
            let ext = file.name.substr(index + 1);
            if (!this.isExcellType(ext)) {
              this.currentStep = 0
              this.$message.warning('只能上传.xls/.xlsx文件!')
            } else {
              this.$axios
                .fetchPostGoodsExport(api.archives.barCodeImport, formData)
                .then(data => {
                  console.log(data)
                  this.currentStep = 2;
                  if (data.code === 200) {
                    this.operationRecordId = data.data
                    this.importStatus = true
                    this.getTableData();
                    this.$notify({
                      type: "success",
                      title: '导入操作',
                      message: '成功',
                      showClose: false,
                    });
                    // return this.$message({message: '导入成功!', type: 'success'})
                  } else {
                    if (data.errorMsg) {
                      return this.$message({message: data.errorMsg, type: 'warning'});
                    } else {
                      return this.$message({message: '导入异常', type: 'error'});
                    }
                  }
                }).catch((err) => {
                console.lg(err)
              }).finally(() => {
                this.currentStep = 3
                this.getTableData()
              });
            }
          });
        }).catch(() => {
        this.showUpload = false
        this.currentStep = 0
      })
    },
    downLoadModel(val) {
      this.$axios.fetchPost(api.archives.downLoadTemplate).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      });
    },
    handleUpdate(val) {
      this.barCodeUpdateShow = true
      this.selectTarget = val
      this.getBarCode(val.barCode)
      this.getTableData()
    },
    handleDetail(val) {
      this.currentBarCodePageNo = 1
      this.barCodeCheckShow = true
      this.getBarCode(val.barCode)
    },
    handleInsertClose() {
      console.log(123)
      this.step = 1
      // this.page.current = 1;
      this.productCode = '';
      this.listShow = false;
      this.getTableData()
    },
    // 一品多码添加条码
    add() {
      let reg = /^[a-z0-9A-Z]+$/
      if (reg.test(this.productCode)) {
        if (this.selectTarget.barCode === this.productCode) {
          return this.$message.warning('附加码不能等于主码！')
        }
        // 验证商品附加码是否存在
        // verifyBarCode
        const getParam = {
          merchantId: this.merchantId,
          barCode: this.selectTarget.barCode,
          code: this.productCode
        }
        this.$axios.fetchGet(api.archives.verifyBarCode, getParam).then(res => {
          // 若为false则允许添加否则提示已存在
          if (!res.data && res.data !== null) {
            this.$axios.fetchPost(api.archives.goodsBarCode, getParam).then(res => {
              // this.$message({
              //   type: 'success',
              //   message: '添加成功'
              // });
              this.$notify({
                type: "success",
                title: '添加操作',
                message: '成功',
                showClose: false,
              });
              this.productCode = ''
              this.getBarCode(this.selectTarget.barCode)
            })
          } else {
            return this.$message.warning('当前附加码已存在')
          }
        })
        // goodsInsertBarCode
        // this.$axios.fetchPost(api.archives.goodsInsertBarCode, {
        //   barcode: this.productCode,
        //   goodsId: this.tableData.param.goodsId
        // }).then(data => {
        //   this.$refs['goodsCode'].getTableData();
        //   this.productCode = ''
        // })
      } else {
        this.$message.warning('请输入有效条码！');
        this.productCode = ''
      }
    },
    getBarCode(barCode) {
      this.barCode = barCode
      this.page.pageSize = this.$utils.getDataByKey(this.$utils.localStorageKeys.pageSize) || 10;
      let searchParam = {
        pageNumber: this.currentBarCodePageNo,
        pageSize: this.codeTablePageSize,
        merchantId: this.merchantId
      };
      Object.assign(searchParam, {barCode: barCode});
      this.$axios.fetchPost(api.archives.getBarCodePage + '/page', searchParam).then(res => {
        if (res.code === 200) {
          this.$nextTick(() => {
            this.codeTableData = res.data.records
            this.barCodeTotal = res.data.total
            this.barCodeUpdateTotal = res.data.total
            // this.page = this.$refs['goodsCode'].page;
            this.$refs['goodsCode'].tableData = res.data.records;
            this.$refs['goodsCode'].page.total = res.data.total;
          })
        }
      })
    },
    rowCheck(val) {
      console.log((val))
      this.selectTarget = val;
      this.step = 2;
      this.getBarCode(val.barCode)
    },
    rowsSelectSubmit(val) {
      console.log((val))
    },
    // 删除一品多码
    deleteMultiCode(val) {
      console.log(val)
      const {id} = val
      console.log(this.selectTarget)
      this.$axios.fetchDelete(api.archives.goodsBarCode, {id: id}).then(res => {
        if (res.code === 200) {
          this.getBarCode(this.selectTarget.barCode)
          this.getTableData()
          this.$notify({
            type: "success",
            title: '删除操作',
            message: '成功',
            showClose: false,
          });
          // this.$message.success('删除成功')
        } else {
          this.$message.error('请求错误')
        }
      })
    },
    insert() {
      this.listShow = true
      this.$nextTick(() => {
        console.log(this.$refs.goodsListOperation)
        this.$refs.goodsListOperation.getTabelData();// table数据
      })
    },

    // 分页获取一品多码和商品关系
    getTableData() {
      const param = {
        pageSize: this.currentPageSize,
        pageNumber: this.currentPageNo,
        merchantId: this.merchantId,
        barCode: this.searChbarCode === '' ? null : this.searChbarCode
      }
      this.$axios.fetchPost(api.archives.goodsBarCode + '/goods/page', param).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.tableDataPage = res.data.records
          this.total = res.data.total
        }
      })
    }
  }
}
</script>

<style scoped>

.setCode .button {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
}

/deep/ .barCodeDialog {
  min-width: 500px;
}

/deep/ .checkBarCode {
  min-width: 350px;
}

/deep/ .checkBarCode.el-dialog {
  width: 20%;
}

.going {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #EAEAEA;
  color: #999999;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  font-family: Microsoft YaHei;
}

.activeGoing {
  width: 50px;
  height: 50px;
  border: 7px solid #E3EEFF;
  border-radius: 50%;
  background: #458CFF;
  line-height: 36px;
  font-size: 20px;
  color: #FFFFFF;
  text-align: center;
}

.centerArrow {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 16px;
  height: 15px;
  color: #D7D7D7;
  line-height: 12px;
  width: 20px;
  padding: 0;
  transform: translate(-50%, -50%);
  webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}

.fadeLine {
  position: relative;
  border: 0.5px dashed #D7D7D7;
  height: 0;
  min-width: 200px;
}

/deep/ .importDialog {
  width: 640px;
  min-width: 640px;
}

/deep/ .el-step__title.is-process {
  color: #458CFF;
}

/deep/ .el-step__head.is-process {
  color: #458CFF;
  border-color: #458CFF;
}
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/BarCodeManage.vue